import React, { useState } from "react";
import { MdDeleteOutline } from "react-icons/md";

function Note({ title, content, onDelete, id, onDragStart, onDragOver, onDrop }) {
    const [isDragging, setIsDragging] = useState(false);
    const [isDragOver, setIsDragOver] = useState(false);

    return (
        <div
            className={`note animate__animated animate__fadeInUp ${isDragging ? 'dragging' : ''} ${isDragOver ? 'drag-over' : ''}`}
            draggable
            onDragStart={(e) => {
                e.dataTransfer.setData("text/plain", id);
                setIsDragging(true);
                onDragStart(e, id);
            }}
            onDragEnd={(e) => {
                setIsDragging(false);
            }}
            onDragEnter={(e) => {
                e.preventDefault();
                setIsDragOver(true);
            }}
            onDragLeave={(e) => {
                e.preventDefault();
                setIsDragOver(false);
            }}
            onDragOver={(e) => {
                e.preventDefault();
                onDragOver(e);
            }}
            onDrop={(e) => {
                e.preventDefault();
                setIsDragOver(false);
                onDrop(e, id);
            }}
        >
            <h1>{title}</h1>
            <p>{content}</p>
            <button onClick={() => onDelete(id)}><MdDeleteOutline size={20} /></button>
        </div>
    );
}

export default Note;
